module.exports = __webpack_public_path__ + "static/media/desktop.3a8b5629.svg";